/*
  Gigi campaign offer (multibuy, e.g. the Nov 2026 birthday 3 for 2).
  Loaded only by snippets/gigi-campaign.liquid, and only acts once that
  snippet's inline script has put `gigi-camp-on` on <html> (inside the
  start/end window, or ?gigi_campaign=preview on a draft theme).

  - Bar: "tap to apply" puts the code on the session in the background
    (/discount/CODE, same method as the signup popup) and never moves the page.
  - Buy box: a card on eligible products, one-time purchase only, that counts
    what is already in the cart and adds the rest of the three in one tap.
  - Cart drawer: a summary of free units and "add 1 more" nudges, rebuilt from
    /cart.js whenever the drawer re-renders.

  Nothing here prices anything: the discount is the Shopify code. Savings are
  only shown when Shopify reports the code as applicable on the cart.
  Fails quiet: any error leaves the page exactly as the theme drew it.
*/
(function () {
  'use strict';
  var html = document.documentElement;
  var cfgEl = document.getElementById('gigi-camp-config');
  if (!cfgEl || !html.classList.contains('gigi-camp-on')) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var CODE = String(C.code || '').toUpperCase();
  if (!CODE) return;
  var GROUP = Number(C.group) > 1 ? Number(C.group) : 3;
  var ELIGIBLE = {};
  (C.products || []).forEach(function (id) { ELIGIBLE[String(id)] = true; });
  var T = C.text || {};

  var state = { cart: null, applied: html.classList.contains('gigi-camp-applied'), applicable: false };

  /* ---------- helpers ---------- */
  function currency() {
    if (state.cart && state.cart.currency) return state.cart.currency;
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(html.lang || 'en-IE', { style: 'currency', currency: currency() }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function cookieHasCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return !!m && decodeURIComponent(m[1]).toUpperCase().split(',').indexOf(CODE) > -1;
  }
  function setApplied(on) {
    state.applied = on;
    html.classList.toggle('gigi-camp-applied', on);
  }
  function refreshTheme() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }
  function openDrawer() {
    var ce = document.querySelector('cart-element[data-cart-drawer]') || document.querySelector('cart-element');
    if (ce && typeof ce.openCartDrawer === 'function') { try { ce.openCartDrawer(); } catch (e) {} return; }
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
  }

  /* Units of each eligible product on one-time lines, the same lines the
     discount Function counts (no subscriptions, no kit or bundle lines). */
  function groups(cart) {
    var out = {}, order = [];
    ((cart && cart.items) || []).forEach(function (it) {
      var pid = String(it.product_id);
      if (!ELIGIBLE[pid] || it.selling_plan_allocation) return;
      var p = it.properties || {};
      if (p._gigi_kit || p._bundleId) return;
      if (!out[pid]) { out[pid] = { pid: pid, title: it.product_title, units: 0, minPrice: it.price, variant: it.variant_id, saved: 0 }; order.push(pid); }
      out[pid].units += it.quantity;
      // What Shopify actually took off this line with a code (the cart only
      // ever holds ours, since applying it replaces any other code).
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === 'discount_code') out[pid].saved += a.amount;
      });
      if (it.price < out[pid].minPrice) out[pid].minPrice = it.price;
    });
    return order.map(function (k) { return out[k]; });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cart = cart;
        var codes = cart.discount_codes || [];
        var match = null;
        for (var i = 0; i < codes.length; i++) if (String(codes[i].code).toUpperCase() === CODE) match = codes[i];
        state.applicable = !!(match && match.applicable);
        setApplied(!!match || cookieHasCode());
        renderCard();
        renderCart();
        return cart;
      })
      .catch(function () {});
  }

  /* The cart API's `discount` field puts the code on the cart (an empty one
     too, it sticks as items arrive) and REPLACES any other code, which is the
     agreed "one code per order". Unlike /discount/CODE it also works on the
     local dev server, and /cart.js then reports it, so the applied state is
     read from the cart rather than assumed. */
  function applyCode() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: CODE })
    })
      .then(function () { refreshTheme(); return fetchCart(); })
      .catch(function () {});
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId || !qty) return Promise.resolve();
    if (btn) btn.disabled = true;
    // Adding applies the code too, so the cart reads "applied" straight away.
    var pre = state.applied ? Promise.resolve() : applyCode();
    return pre.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      });
    }).then(function (r) {
      if (r && r.ok) {
        openDrawer();
        refreshTheme();
        document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
        requestAnimationFrame(function () { requestAnimationFrame(openDrawer); });
      }
      return fetchCart();
    }).catch(function () {}).then(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- bar ---------- */
  var applyBtn = document.querySelector('[data-gc-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      applyBtn.disabled = true;
      applyCode().then(function () { applyBtn.disabled = false; });
    });
  }

  /* ---------- buy box card ---------- */
  var cards = [];
  function mountCards() {
    if (!C.productId || !ELIGIBLE[String(C.productId)]) return;
    var buys = document.querySelectorAll('[data-pdp-buy]');
    for (var i = 0; i < buys.length; i++) {
      var buy = buys[i];
      var root = buy.closest('.shopify-section') || buy.parentNode;
      if (!root || root.querySelector('.gigi-camp-card')) continue;
      var once = root.querySelector('[data-pdp-type="onetime"]');
      var subBlock = root.querySelector('[data-pdp-subblock]');
      var card = buildCard(root);
      if (once && subBlock) subBlock.parentNode.insertBefore(card.node, subBlock);
      else buy.parentNode.insertBefore(card.node, buy);
      if (subBlock && T.sub) {
        // Subscribe & save is the default on most PDPs, so the note offers the
        // way back to one-time, where the card lives.
        var note = el('p', 'gigi-camp-note', T.sub + ' ');
        if (once) {
          var sw = el('button', 'gigi-camp-note__switch', 'Switch to one-time');
          sw.type = 'button';
          sw.addEventListener('click', (function (o) { return function () { o.click(); }; })(once));
          note.appendChild(sw);
        }
        subBlock.appendChild(note);
        card.note = note;
      }
      card.once = once;
      // With the buy box's one-time quantity box on the page, the card works
      // with it: it reads the chosen quantity and its button sets it.
      card.qty = root.querySelector('[data-pdp-qty-input]');
      cards.push(card);
      if (once && window.MutationObserver) {
        new MutationObserver(syncCardVisibility).observe(once, { attributes: true, attributeFilter: ['class'] });
      }
    }
    syncCardVisibility();
    renderCard(); // never blank: empty-cart copy until /cart.js answers
  }
  function buildCard(root) {
    var node = el('div', 'gigi-camp-card');
    node.setAttribute('data-gigi-camp-card', '');
    var top = el('div', 'gigi-camp-card__top');
    if (T.tag) top.appendChild(el('span', 'gigi-camp-card__tag', T.tag));
    if (T.ends) top.appendChild(el('span', 'gigi-camp-card__ends', T.ends));
    var h = el('p', 'gigi-camp-card__h');
    var p = el('p', 'gigi-camp-card__p');
    var bar = el('div', 'gigi-camp-card__bar');
    var fill = el('div', 'gigi-camp-card__fill');
    bar.appendChild(fill);
    bar.setAttribute('aria-hidden', 'true');
    var btn = el('button', 'gigi-camp-card__btn');
    btn.type = 'button';
    node.appendChild(top); node.appendChild(h); node.appendChild(p); node.appendChild(bar); node.appendChild(btn);
    var card = { node: node, h: h, p: p, fill: fill, btn: btn, root: root, add: 0 };
    btn.addEventListener('click', function () {
      if (card.qty) {
        card.qty.value = card.setTo;
        card.qty.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var idInput = root.querySelector('[data-pdp-id]');
      var vid = idInput && idInput.value;
      addToCart(vid, card.add, btn);
    });
    return card;
  }
  function syncCardVisibility() {
    cards.forEach(function (c) {
      var oneTime = !c.once || c.once.classList.contains('is-active');
      c.node.hidden = !oneTime;
      if (c.note) c.note.hidden = oneTime;
    });
  }
  function renderCard() {
    if (!cards.length) return;
    var g = groups(state.cart).filter(function (x) { return x.pid === String(C.productId); })[0];
    var n = g ? g.units : 0;
    var rem = n % GROUP;
    var add = GROUP - rem;
    var unit = Number(C.price) || (g ? g.minPrice : 0);
    var free = Math.floor(n / GROUP);
    var heading, body;
    if (n === 0) {
      heading = T.heading; body = T.body;
    } else if (rem === 0) {
      heading = n + ' in your cart, ' + free + ' free.';
      body = 'Every ' + ordinal(GROUP) + ' one is free, so keep going if you like.';
    } else {
      heading = n + ' in your cart. Add ' + add + ' more and one is free.';
      body = T.body;
    }
    // Price of the units added: the last one of the group is the free one.
    var cost = Math.max(0, add - 1) * unit;
    var label = String(T.button || 'Add [qty] · [price]')
      .replace('[qty]', String(add))
      .replace('[price]', cost > 0 ? money(cost) : 'free');
    cards.forEach(function (c) {
      if (c.qty) { renderBoxCard(c, n, unit); return; }
      c.h.textContent = heading || '';
      c.p.textContent = body || '';
      c.p.hidden = !body;
      c.fill.style.width = Math.round(((rem === 0 && n > 0) ? GROUP : rem) / GROUP * 100) + '%';
      c.fill.parentNode.hidden = n === 0;
      c.btn.textContent = label;
      c.add = add;
    });
  }
  /* Box mode: progress counts what's in the cart plus the quantity chosen in
     the box (not yet added). The button sets the box so the total lands on
     the next free one. */
  function renderBoxCard(c, inCart, unit) {
    var chosen = Math.max(1, parseInt(c.qty.value, 10) || 1);
    var total = inCart + chosen;
    var rem = total % GROUP;
    var free = Math.floor(total / GROUP);
    var heading, body;
    if (rem === 0) {
      heading = free === 1 ? 'Your ' + ordinal(GROUP) + ' one is free.' : free + ' free with ' + CODE + '.';
      body = (inCart ? inCart + ' already in your cart. ' : '') + (free === 1 ? 'Add to cart and the free one comes off at checkout.' : 'Add to cart and the free ones come off at checkout.');
    } else {
      heading = 'Add ' + (GROUP - rem) + ' more, get 1 free.';
      body = (inCart ? inCart + ' already in your cart. ' : '') + (T.body || '');
    }
    c.setTo = chosen + (rem === 0 ? 0 : GROUP - rem);
    c.h.textContent = heading;
    c.p.textContent = body;
    c.p.hidden = !body;
    c.fill.parentNode.hidden = total === 0;
    c.fill.style.width = Math.round(((rem === 0) ? GROUP : rem) / GROUP * 100) + '%';
    c.btn.hidden = rem === 0;
    c.btn.textContent = String(T.set || 'Make it [qty]').replace('[qty]', String(c.setTo));
  }
  document.addEventListener('gigi:pdp:qty', function () { renderCard(); });
  /* Box mode: the buy box's own Add to cart does the adding, so apply the
     code once that add brings this product to a free one, as the card's own
     button does without a box (same "one code per order" replace). */
  document.addEventListener('theme:cart:added', function () {
    if (!cards.some(function (c) { return c.qty; })) return;
    setTimeout(function () {
      fetchCart().then(function () {
        if (state.applied) return;
        var g = groups(state.cart).filter(function (x) { return x.pid === String(C.productId); })[0];
        if (g && g.units >= GROUP) applyCode();
      });
    }, 200);
  });

  function ordinal(n) { return n === 2 ? '2nd' : n === 3 ? '3rd' : n + 'th'; }

  /* ---------- cart drawer ---------- */
  function renderCart() {
    var bodies = document.querySelectorAll('[data-cart-drawer-body]');
    var gs = groups(state.cart);
    for (var i = 0; i < bodies.length; i++) {
      var body = bodies[i];
      var old = body.querySelector('.gigi-camp-cart');
      if (old) old.parentNode.removeChild(old);
      if (gs.length) body.insertBefore(buildCart(gs), body.firstChild);
    }
  }
  function buildCart(gs) {
    var box = el('div', 'gigi-camp-cart');
    box.setAttribute('data-gigi-camp-cart', '');
    var head = el('p', 'gigi-camp-cart__head');
    head.style.margin = '0';
    if (T.tag) head.appendChild(el('span', null, T.tag));
    head.appendChild(document.createTextNode(state.applied ? CODE + ' applied' : '3 for 2 with ' + CODE));
    box.appendChild(head);
    if (!state.applied) {
      var row = el('div', 'gigi-camp-cart__row');
      row.appendChild(el('span', null, 'Buy 3 of the same product, the 3rd is free.'));
      var b = el('button', 'gigi-camp-cart__btn', 'Apply');
      b.type = 'button';
      b.addEventListener('click', function () { b.disabled = true; applyCode(); });
      row.appendChild(b);
      box.appendChild(row);
      return box;
    }
    gs.forEach(function (g) {
      var free = Math.floor(g.units / GROUP);
      var rem = g.units % GROUP;
      // The saving shown is Shopify's own allocation, never our arithmetic.
      if (free > 0 && state.applicable && g.saved > 0) {
        var r1 = el('div', 'gigi-camp-cart__row');
        r1.appendChild(el('span', null, g.title + ': ' + free + ' free'));
        r1.appendChild(el('b', null, '−' + money(g.saved)));
        box.appendChild(r1);
      }
      if (rem !== 0) {
        var need = GROUP - rem;
        var r2 = el('div', 'gigi-camp-cart__row');
        r2.appendChild(el('span', null, need === 1 ? 'Add 1 more ' + g.title + ' and it’s free.' : 'Add ' + need + ' more ' + g.title + ', get 1 free.'));
        var add = el('button', 'gigi-camp-cart__btn', need === 1 ? 'Add free' : 'Add 1');
        add.type = 'button';
        add.addEventListener('click', function () { addToCart(g.variant, 1, add); });
        r2.appendChild(add);
        box.appendChild(r2);
      }
    });
    return box;
  }

  // The drawer re-renders its body on every cart change; rebuild after it.
  // Only the drawer is watched, and only for changes that are not our own
  // panel, so tickers and sliders elsewhere never trigger a /cart.js call.
  var t = null;
  function scheduleRefresh() { clearTimeout(t); t = setTimeout(fetchCart, 150); }
  function ours(node) {
    return node.nodeType === 1 && (node.classList.contains('gigi-camp-cart') || (node.closest && node.closest('.gigi-camp-cart')));
  }
  function foreign(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.target.closest && r.target.closest('.gigi-camp-cart')) continue;
      var nodes = Array.prototype.slice.call(r.addedNodes).concat(Array.prototype.slice.call(r.removedNodes));
      if (!nodes.length) return true;
      for (var j = 0; j < nodes.length; j++) if (!ours(nodes[j])) return true;
    }
    return false;
  }
  var drawer = document.querySelector('cart-element[data-cart-drawer]');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function (records) { if (foreign(records)) scheduleRefresh(); })
      .observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('theme:cart:added', scheduleRefresh);

  mountCards();
  fetchCart();
})();
